import { Directive, ElementRef, OnDestroy, OnInit, inject } from '@angular/core';
import { AgGridAngular } from 'ag-grid-angular';

@Directive({
  selector: 'ag-grid-angular[autoFitWidth]',
  standalone: false,
})
export class AgGridAutoFitWidthDirective implements OnInit, OnDestroy {
  private readonly host = inject(ElementRef);
  private readonly agGrid = inject(AgGridAngular);

  observer: ResizeObserver;

  ngOnInit(): void {
    this.observer = new ResizeObserver(() => {
      this.agGrid.api.sizeColumnsToFit();
    });
    this.observer.observe(this.host.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.unobserve(this.host.nativeElement);
  }

}
